{
  "id": "cfop",
  "nome": "CONFAZ CFOP",
  "fonte": "CONFAZ SINIEF Convênio s/nº 1970 — Anexo II",
  "endpoints": [
    "https://www.confaz.fazenda.gov.br/legislacao/ajustes/sinief/cfop_cvsn_70_vigente",
    "/home/runner/work/br-validators/br-validators/data/source-mirrors/confaz/cfop_cvsn_70_vigente.html"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T05:22:11.808Z",
  "contagens": {
    "cfop": 689
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T05:22:11.808Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#cfop-fiscal-operations"
}
